export enum RequestStates {
    PRESENTED = 10,
    PREPARED = 40,
    PREPARED_DOCK = 20,
    DOCK = 50,
    DOCK_END = 60,
    EXIT = 80,
}

export enum RequestStateSort {
    SUBMITTED = 10,
    ENTRY = 20,
    PREPARED = 40,
    DOCK = 50,
    DOCK_END = 60,
    EXIT = 80
}

